import {
  DELETE_SHIPPING_PROVIDER,
  INSERT_SHIPPING_PROVIDER
} from 'graphql/mutations/integrations';
import * as Yup from 'yup';

const bigSmartData = {
  key: 'BigMoveSmart',
  createMutation: INSERT_SHIPPING_PROVIDER,
  deleteMutation: DELETE_SHIPPING_PROVIDER,
  noDisplayFields: [
    { name: 'clientId', path: 'clientId' },
    { name: 'providerId', path: 'id' }
  ],
  getMixedTypes: (params) => {
    return {
      service: () => {
        const notAvailableItems = params?.integrationsData?.map(
          (item) => item.service
        );

        return ['NACIONAL', 'PROGRAMADO', 'EXPRESS'].filter(
          (item) => !notAvailableItems?.includes(item)
        );
      }
    };
  },
  fields: [
    {
      title: 'Alias',
      label: 'Ej. Primera integración',
      keyName: 'alias',
      type: '',
      initialValue: '',
      helperText: 'Introduce un nombre para identificar esta integración',
      validationSchema: Yup.string().required('Ingresa el campo Alias')
    },
    {
      title: 'Servicio',
      label: 'Ej. PROGRAMADO',
      keyName: 'service',
      type: [],
      initialValue: '',
      helperText: 'Introduce el tipo de servicio',
      validationSchema: Yup.string().required('Ingresa el campo SERVICIO')
    },
    {
      label: 'Metadata',
      keyName: 'metadata',
      type: {},
      fields: [
        {
          title: 'USER',
          label: 'Ej: user_example',
          keyName: 'user',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu USER',
          validationSchema: Yup.string().required('Ingresa el campo USER')
        },
        {
          title: 'PASSWORD',
          label: 'Ej: password_example',
          keyName: 'password',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu PASSWORD',
          validationSchema: Yup.string().required('Ingresa el campo PASSWORD')
        },
        {
          title: 'CARRIER NAME',
          label: 'Ej: carrier_name_example',
          keyName: 'carrierName',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu CARRIER NAME',
          validationSchema: Yup.string().required(
            'Ingresa el campo CARRIER NAME'
          )
        },
        {
          title: 'PRIMARY CLIENT',
          label: 'Ej: primary_client_example',
          keyName: 'primaryClient',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu PRIMARY CLIENT',
          validationSchema: Yup.string().required(
            'Ingresa el campo PRIMARY CLIENT'
          )
        }
      ]
    }
  ]
};

export default bigSmartData;
